import React, { useState } from 'react'

import { Box } from '@mui/material'
import { startOfWeek, endOfWeek, format } from 'date-fns'
import { useSelector } from 'react-redux'
import { RootState } from '../../../reducers'
import WeeklyCalendar from './WeeklyCalendar'
import { MonthlyCalendarContainer } from '../MonthlyCalendarContainer'
import { UserBanner } from './../../HOC/UserBanner'
import { dropDownUser } from './../../../interfaces/common'
import './AdminCalendar.css'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

export function AdminCalendar(): JSX.Element | null {
  const [weekView, setWeekView] = useState(true)
  const [calendarUserId, setCalendarUserId] = useState<string | null>(null)
  const [userInfo, setUserInfo] = useState<dropDownUser | null>(null)
  const { role } = useSelector((state: RootState) => state.userLogin)
  const startOfBootWeek = format(startOfWeek(new Date(), { weekStartsOn: 0 }), 'yyyy-MM-dd')
  const endOfBootWeek = format(endOfWeek(new Date(), { weekStartsOn: 0 }), 'yyyy-MM-dd')

  const updateUserView = (e, doctor) => {
    if (!doctor) {
      setWeekView(true)
      setUserInfo(null)
    }
    if (doctor.id || doctor.user_id) {
      setCalendarUserId(doctor.id || doctor.user_id)

      const docInfo = {
        user_id: doctor.id || doctor.user_id,
        user_name: doctor.user_name || `${doctor.last_name}, ${doctor.first_name}`,
      }

      setUserInfo(docInfo)
      setWeekView(false)
    }
  }

  return (
    <Box className="">
      <UserBanner updateUserView={updateUserView} userInfo={userInfo} />

      {weekView ? (
        <WeeklyCalendar startdate={startOfBootWeek} enddate={endOfBootWeek} handleChange={updateUserView} />
      ) : (
        <MonthlyCalendarContainer user={calendarUserId} role={role} key={calendarUserId} />
      )}
    </Box>
  )
}
